var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleAddGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#23BD86"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7917 10.625H10.625V14.7917C10.625 14.9068 10.5318 15 10.4167 15H9.58333C9.46823 15 9.375 14.9068 9.375 14.7917V10.625H5.20833C5.09323 10.625 5 10.5318 5 10.4167V9.58333C5 9.46823 5.09323 9.375 5.20833 9.375H9.375V5.20833C9.375 5.09323 9.46823 5 9.58333 5H10.4167C10.5318 5 10.625 5.09323 10.625 5.20833V9.375H14.7917C14.9068 9.375 15 9.46823 15 9.58333V10.4167C15 10.5318 14.9068 10.625 14.7917 10.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleAddGreen);
export default __webpack_public_path__ + "static/media/Circle-add-green.ce0b04dd8302433711a9eabb1b73e819.svg";
export { ForwardRef as ReactComponent };